// extracted by mini-css-extract-plugin
export var providerSummary2 = "ProviderSummary2-module--providerSummary2--2AXKS";
export var imageWrapper = "ProviderSummary2-module--imageWrapper--1o5P5";
export var contentWrapper = "ProviderSummary2-module--contentWrapper--Y4wOh";